import React, { useState, useEffect } from "react";
import { Grid, Divider, Button, Header } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { decryptData, secretKey } from "../store/Encrypt";
import Cookies from "js-cookie";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const DataInvIndiaCatogeryList = () => {
  const navigate = useNavigate();
  const [rowData, setrowData] = useState([]);
  const userDetail = userData();
  useEffect(() => {
    getWorkCatList();
  }, []);

  const getWorkCatList = () => {
    axios
      .post(BaseUrl + "/listSSVisaCategory", {
        ssVisaId: "",
        visaTypeNumber: 35565,
      })
      .then((res) => {
        console.log("Original data:", res.data);
        const sortedData = res.data.sort((a, b) => {
          console.log("Comparing:", a.visaCategory, b.visaCategory);
          return a.visaCategory?.localeCompare(b.visaCategory);
        });
        console.log("Sorted data:", sortedData);
        setrowData(sortedData);
      })
      .catch((error) => console.log(error));
  };

  const columnDefs = [
    { headerName: "Ticket Category", field: "visaCategory" },

    {
      headerName: "Action",
      field: "categoryId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            edit
          </Button>{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteItem(params)}>
              delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const deleteItem = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Deleted!", "Your file has been deleted.", "success");
        axios
          .post(BaseUrl + "deleteSSVisaCategory", {
            visaCategoryId: params.data.visaCategoryId,
          })
          .then((res) => {
            console.log(res.data);
            Swal.fire(
              "Deleted!",
              " Ticket category  has been deleted.",
              "success"
            );
            getWorkCatList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const actionButton = (params) => {
    // console.log("Params", params.data);
    navigate(`/data-inv-catogery-india-create/${params.data.visaCategoryId}`);
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Data Entry category List (INDIA)
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Button
          type="submit"
          primary
          onClick={() => navigate("/data-inv-catogery-india-create/null")}
        >
          Create New
        </Button>
      </Grid.Row>
      <Divider hidden /> <Divider />
      <div className="ag-theme-alpine" style={{ height: 600 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
        ></AgGridReact>
      </div>
    </div>
  );
};

export default DataInvIndiaCatogeryList;
